export const BOARD_GAP = 2;
const MIN_TILE_SIZE = 36;

const getMaxTileSize = (cols) => {
  if (cols <= 4) return 96;
  if (cols <= 5) return 72;
  return 64;
};

export const computeBoardTileSize = ({
  width,
  height = 0,
  cols,
  rows,
  gap = BOARD_GAP,
  reserveBottom = 0,
}) => {
  if (!width || !cols || !rows) return 60;

  let tileSize = (width - gap * (cols - 1)) / cols;
  const maxTileSize = getMaxTileSize(cols);
  tileSize = Math.min(Math.floor(tileSize), maxTileSize);

  const availableHeight = height > 0 ? Math.max(0, height - reserveBottom) : 0;
  if (availableHeight > 0) {
    const boardHeight = tileSize * rows + gap * (rows - 1);
    if (boardHeight > availableHeight) {
      tileSize = Math.floor((availableHeight - gap * (rows - 1)) / rows);
    }
  }

  return Math.max(MIN_TILE_SIZE, tileSize);
};
